import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2026-03-13 15:47:48 +0100 (Fri, 13 Mar 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 161511 $
//  Purpose   : headers
// =============================================================================
// ---Third-party imports
import React from 'react';
import clsx from 'clsx';
// ---Framework imports
import log from 'uix/logging';
import { GenericTagHandler } from 'uix/wiki/utils';
import { decodeAttribH5 } from 'uix/utils';
import S from './header.css';
export const FancyHeader = GenericTagHandler('XHeader', ({ attrib, children, text, applyTemplates })=>{
    let { ghosted, secondary, light, underlined } = decodeAttribH5(attrib);
    let cls = {
        [S.header]: true,
        [S.ghosted]: ghosted,
        [S.secondary]: secondary,
        [S.light]: light
    };
    return /*#__PURE__*/ _jsx("div", {
        className: S.headerContainer,
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("header", {
                    className: clsx(S.header, light && S.light),
                    children: [
                        text,
                        applyTemplates(children)
                    ]
                }),
                underlined && /*#__PURE__*/ _jsx("div", {
                    className: S.underlined,
                    children: ''
                }),
                ghosted && /*#__PURE__*/ _jsx("header", {
                    className: clsx(S.ghosted, light && S.light),
                    children: [
                        text,
                        applyTemplates(children)
                    ]
                })
            ]
        })
    });
}, {
    ghosted: [
        true,
        false
    ],
    secondary: [
        true,
        false
    ]
});
